/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface TrackInPlaceActionArgs {
  /** Arbitrary string name (not required) */
  name: string;
}

export interface TrackInPlaceResultData {
}

export interface TrackInPlaceActionStateData {
}

function createBaseTrackInPlaceActionArgs(): TrackInPlaceActionArgs {
  return { name: "" };
}

export const TrackInPlaceActionArgs = {
  encode(message: TrackInPlaceActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackInPlaceActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackInPlaceActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrackInPlaceActionArgs {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: TrackInPlaceActionArgs): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackInPlaceActionArgs>, I>>(base?: I): TrackInPlaceActionArgs {
    return TrackInPlaceActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackInPlaceActionArgs>, I>>(object: I): TrackInPlaceActionArgs {
    const message = createBaseTrackInPlaceActionArgs();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseTrackInPlaceResultData(): TrackInPlaceResultData {
  return {};
}

export const TrackInPlaceResultData = {
  encode(_: TrackInPlaceResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackInPlaceResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackInPlaceResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TrackInPlaceResultData {
    return {};
  },

  toJSON(_: TrackInPlaceResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackInPlaceResultData>, I>>(base?: I): TrackInPlaceResultData {
    return TrackInPlaceResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackInPlaceResultData>, I>>(_: I): TrackInPlaceResultData {
    const message = createBaseTrackInPlaceResultData();
    return message;
  },
};

function createBaseTrackInPlaceActionStateData(): TrackInPlaceActionStateData {
  return {};
}

export const TrackInPlaceActionStateData = {
  encode(_: TrackInPlaceActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackInPlaceActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackInPlaceActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TrackInPlaceActionStateData {
    return {};
  },

  toJSON(_: TrackInPlaceActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackInPlaceActionStateData>, I>>(base?: I): TrackInPlaceActionStateData {
    return TrackInPlaceActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackInPlaceActionStateData>, I>>(_: I): TrackInPlaceActionStateData {
    const message = createBaseTrackInPlaceActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
